module.exports = __webpack_public_path__ + "static/img/2.0993cb7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/2/sp/2.png
// module id = XOY/
// module chunks = 0